import { postData } from 'helpers/RequestHelper';

export const validateInfo = (lastName, last4ssn) => {
  const body = { last_name: lastName, last_4_ssn: last4ssn };
  return postData({
    url: '/register/lead_gate',
    body
  })
    .then((response) => response)
    .catch((error) => {
      window.Raven.captureException(error);
      const phone = document.getElementById('mainPhoneNumber');
      window.toastr.error(
        null,
        `Something went wrong. Refresh and submit again, Call us at ${phone.textContent} if this issue persists.`
      );
      return error.response;
    });
};
